module.exports = __webpack_public_path__ + "media/images/client-38-a52531e72c442d6a072578dfeea7fbcb.png";